import { useCallback, useState } from 'react';
import { readStored, writeStored } from '@/lib/storage';

const KEY = 'lemon.app.sidebar.rail';

/** The user's collapse choice for the desktop sidebar, remembered per browser. */
export function useSidebarRail(): [boolean, () => void] {
  const [rail, setRail] = useState(() => readStored(KEY) === '1');
  const toggle = useCallback(() => {
    setRail((current) => {
      writeStored(KEY, current ? '0' : '1');
      return !current;
    });
  }, []);
  return [rail, toggle];
}
